export const ROOT_BRANCH_ID = 'root';
import { EdgeTypes as ServerEdgeTypes } from '@ply-io/ply-front-shared-utilities';

export enum NodeTypes {
	Setup = 'setup',
	Custom = 'custom',
	EndRun = 'end-run',
	Element = 'element',
	LoopEnd = 'loop-end',
	LoopStart = 'loop-start',
	BranchRoot = 'branch-root',
	ToolTrigger = 'tool-trigger',
	AddOnTrigger = 'add-on-trigger',
	LoopConnector = 'loop-connector',
	VirtualContextual = 'virtual-contextual',
	SkippedContextual = 'skipped-contextual',
	BranchConsolidate = 'branch-consolidate',
	EmptyNodePlusPlaceholder = 'empty-node-plus-placeholder',
}

export enum LocalEdgeTypes {
	Default = 'default',
	Regular = 'regular',
	Invisible = 'invisible',
	AnimatedHelpEdge = 'animated_help_edge',
}
export type EdgeType = ServerEdgeTypes | LocalEdgeTypes;
export const EdgeTypes = { ...ServerEdgeTypes, ...LocalEdgeTypes } as const;
export { EdgeTypes as ServerEdgeTypes } from '@ply-io/ply-front-shared-utilities';
